<template>
  <div>
    <el-dialog
      center
      title="问答名称"
      :visible.sync="show"
      class="top-draft-dialog topicDialog"
      :before-close="handleClose"
    >
      <div class="m-b-10" style="padding: 0 70px">
        <div class="flex" style="justify-content: space-around; margin: 20px 0">
          <span> 提交人: {{ item.name }} </span>
          <span> 总题数: {{ item.finishedNum }} </span>
          <span>
            得分: {{ item.userScore }}（总分:{{ item.totalScore }}）
          </span>
        </div>
        <p>姓名:&emsp;{{ item.name }}</p>
        <p>电话:&emsp;{{ item.phone }}</p>
        <div style="margin-top: 30px">
          <div
            style="margin-bottom: 30px"
            v-for="(data, index) in item.questions"
            :key="index"
          >
            <h5 v-if="data.type == 0 || data.type == 1 || data.type == 2">
              {{ index + 1 }}. {{ data.title }} （得分:{{ data.score }}分）
            </h5>
            <h5 style="line-height: 45px" v-if="data.type == 3">
              {{ index + 1 }}.
              <!-- <span v-for="(val, m) in singTitle" :key="m"> -->
              {{ singTitle[0] }}&emsp;<span
                v-if="data.choseAnswers[0]"
                style="border-bottom: 2px solid #333; padding: 0 20px"
                :style="{
                  color: data.choseAnswers[0].corr == true ? '#13ce66' : 'red',
                }"
                >{{ data.choseAnswers[0].content }}</span
              >&emsp;（得分:{{ data.score }}分）
            </h5>

            <h5 style="line-height: 45px" v-if="data.type == 4">
              {{ index + 1 }}.
              <span v-for="(val, m) in multTitle" :key="m">
                {{ val }}&emsp;<span
                  v-if="data.choseAnswers[m]"
                  style="border-bottom: 2px solid #333; padding: 0 20px"
                  :style="{
                    color: data.choseAnswers[m].corr ? '#13ce66' : 'red',
                  }"
                  >{{ data.choseAnswers[m].content }}</span
                >&emsp;
              </span>
              （得分:{{ data.score }}分）
            </h5>

            <div v-if="data.type == 0 || data.type == 1 || data.type == 2">
              <!-- 答案列表 -->
              <div v-for="(item, i) in data.answers" :key="i">
                <el-radio
                  v-if="item.corr"
                  :class="{ 'is-checked': item.used }"
                  class="correctText flex"
                  style="margin: 10px 0; width: 100%; align-items: center"
                  :label="item.content"
                >
                </el-radio>
                <el-radio
                  :class="{ 'is-checked': item.used }"
                  v-if="item.err"
                  class="errText flex"
                  style="margin: 10px 0; width: 100%; align-items: center"
                  :label="item.content"
                >
                </el-radio>
                <el-radio
                  class="flex"
                  :class="{ 'is-checked': item.used }"
                  v-if="!item.err && !item.corr"
                  style="margin: 10px 0; width: 100%; align-items: center"
                  :label="item.content"
                >
                </el-radio>
                <!-- <span v-for="(subData, y) in data.choseAnswers" :key="y + 's'">
                  <span>
                    {{ subData.content }}
                  </span>
                </span> -->
              </div>
            </div>
          </div>
        </div>
        <div style="margin-bottom: 20px" class="m-b-10">
          *回答正确标为绿色，回答错误标为红色
        </div>
      </div>

      <!-- <div style="text-align: end">
        <el-button style="margin: 10px" type="primary" @click="show = false"
          >关 闭</el-button
        >
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
import question from "@/server/api/question.js";
export default {
  data() {
    return {
      show: false,
      topicList: [
        {
          title: "单选题",
          score: 5,
          type: "radio",
          subtitle: [
            { title: "选项一" },
            { title: "选项二" },
            { title: "选项三" },
          ],
          correct: "选项二",
          Selected: "选项一",
        },
        {
          title: "多选题",
          score: 5,
          type: "multi",
          subtitle: [
            { title: "选项一", state: 1 },
            { title: "选项二", state: 1 },
            { title: "选项三", state: 1 },
            { title: "选项四", state: 2 },
            { title: "选项五", state: 0 },
          ],
          Selected: ["选项一", "选项三", "选项四"],
        },
        // {
        //   title: "多选题",
        //   score: 5,
        //   type: "multi",
        //   subtitle: ["选项一", "选项二", "选项三"],
        //   correct: ["选项一", "选项二"],
        //   Selected: ["选项二", "选项三"],
        // },
        // {
        //   title: "多选题",
        //   score: 5,
        //   type: "multi",
        //   subtitle: ["选项一", "选项二", "选项三"],
        //   correct: ["选项三"],
        //   Selected: ["选项二", "选项三"],
        // },
      ],
      item: {},
      value: "",
      multTitle: [],
      singTitle: [],
    };
  },

  props: {},

  mounted() {
    // this.tagSearch();
  },
  methods: {
    showModel(id) {
      this.show = true;
      this.getList(id);
    },
    handleClose() {
      this.show = false;
    },
    getList(id) {
      let params = { id: id };
      question.historyDetail(params).then((res) => {
        this.item = res.data;
        // this.item.questions[0].correctAnswers[0].content = "测试答案1"; //正确答案
        // this.item.questions[0].choseAnswers[0].content = "测试答案4"; //用户选择的答案

        // this.item.questions[1].correctAnswers[0].content = "测试答案2"; //正确答案
        // this.item.questions[1].correctAnswers.push({ content: "测试答案3" }); //正确答案
        // this.item.questions[1].choseAnswers[0].content = "测试答案2"; //用户选择的答案
        // this.item.questions[1].choseAnswers.push({ content: "测试答案4" }); //用户选择的答案

        // this.item.questions[3].choseAnswers[0].content = "测试答案2"; //用户选择的答案
        // this.item.questions[0].correctAnswers.push({ content: "测试答案3" }); //正确答案
        // this.item.questions[0].correctAnswers.push({ content: "测试答案1" }); //正确答案

        // this.item.questions[4].title =
        //   "测试填空问题___测试填空问题2___测试填空问题3___";
        // this.item.questions[4].correctAnswers.push({
        //   content: "测试答案2",
        // });
        // this.item.questions[4].correctAnswers.push({
        //   content: "测试答案3",
        // });
        // this.item.questions[4].choseAnswers.push({ content: "测试答案4" });
        // this.item.questions[4].choseAnswers.push({ content: "测试答案1" });

        this.item.questions.forEach((item) => {
          if (item.type == 0 || 1 || 2) {
            item.answers.forEach((v, i) => {
              item.correctAnswers.forEach((k) => {
                if (k.content === v.content) {
                  item.answers[i].corr = true;
                }
              });
              item.choseAnswers.forEach((y) => {
                if (y.content == v.content) {
                  item.answers[i].used = true;
                }
                if (y.content == v.content && !v.corr) {
                  item.answers[i].err = true;
                }
              });
            });
          }
          if (item.type == 3) {
            // item.title = "测试填空问题___测试填空问题2___";
            // item.correctAnswers.push({ content: "测试填空问题2" });
            // item.choseAnswers.push({ content: "测试填空问题4" });
            //用戶选择的答案
            item.choseAnswers.forEach((v, i) => {
              let strArr = item.title.split("____");
              strArr = strArr.filter((item) => item && item.trim());
              // console.log(item.choseAnswers); //用户选中答案
              // console.log(item.correctAnswers); //正确答案
              this.singTitle = strArr;
              item.choseAnswers.forEach((v, i) => {
                if (v.content && v.content == item.correctAnswers[i].content) {
                  item.choseAnswers[i].corr = true;
                } else {
                  item.choseAnswers[i].err = true;
                }
              });
              // let newStr = "";
              // if (v.content == item.correctAnswers[i].content) {
              //   console.log("正确");
              //   strArr.forEach((v, k) => {
              //     newStr +=
              //       v +
              //       "&emsp;<span style='border-bottom:2px solid #333;color:#13ce66;padding: 0 20px;'>" +
              //       item.choseAnswers[0].content +
              //       "</span>";
              //   });
              // }
              // if (v.content != item.correctAnswers[i].content) {
              //   strArr.forEach((v, k) => {
              //     newStr +=
              //       v +
              //       "&emsp;<span style='border-bottom:2px solid #333;color:red;padding: 0 20px;'>" +
              //       item.choseAnswers[k].content +
              //       "</span>";
              //   });
              // }

              // if (v.content == item.correctAnswers[i].content) {
              //   let strArr = item.title.split("___");
              //   strArr = strArr.filter((item) => item && item.trim());
              //   console.log(strArr);
              //   // item.title = strArr;
              //   strArr.forEach((v, k) => {
              //     newStr +=
              //       v +
              //       "&emsp;<span style='border-bottom:2px solid #333;color:#13ce66;padding: 0 20px;'>" +
              //       item.choseAnswers[k].content +
              //       "</span>";
              //     // item.title =
              //     //   v +
              //     //   "&emsp;<span style='border-bottom:2px solid #333;color:#13ce66;padding: 0 20px;'>" +
              //     //   item.choseAnswers[k].content +
              //     //   "</span>";
              //   });
              // }

              // else {
              //   let strArr = item.title.split("___");
              //   strArr = strArr.filter((item) => item && item.trim());
              //   // item.title = strArr;
              //   strArr.forEach((v, k) => {
              //     console.log(v);
              //     newStr +=
              //       v +
              //       "&emsp;<span style='border-bottom:2px solid #333;color:red;padding: 0 20px;'>" +
              //       item.choseAnswers[k].content +
              //       "</span>";
              //   });
              // }
              // console.log(newStr);
              // item.title = newStr;
            });
          }
          if (item.type == 4) {
            let strArr = item.title.split("____");
            strArr = strArr.filter((item) => item && item.trim()); //标题
            this.multTitle = strArr;
            // console.log(this.multTitle);
            // console.log(item.choseAnswers); //用户选中答案
            // console.log(item.correctAnswers); //正确答案
            item.choseAnswers.forEach((v, i) => {
              if (v.content && v.content == item.correctAnswers[i].content) {
                item.choseAnswers[i].corr = true;
              } else {
                item.choseAnswers[i].err = true;
              }
            });
          }
        });
      });
    },
    checkType(num) {
      if (num == 0) {
        return "单选题";
      }
      if (num == 1) {
        return "多选题";
      }
      if (num == 2) {
        return "判断题";
      }
      if (num == 3) {
        return "单项填空题";
      }
      if (num == 4) {
        return "多项填空题";
      }
    },
  },
};
</script>
<style scoped>
::v-deep .el-radio__label {
  display: inline-block;
  width: 100%;
  white-space: pre-wrap;
  line-height: 20px;
}
</style>
<style lang="scss">
.top-draft-dialog .el-dialog {
  .correctText {
    .el-radio__label {
      color: #13ce66 !important;
      font-size: 0.8125rem !important;
    }
  }
  .errText {
    .el-radio__label {
      color: red !important;
      font-size: 0.8125rem !important;
    }
  }
  .is-checked {
    .el-radio__inner {
      background: #556ee6 !important;
      // border-color: #556ee6 !important;
    }
  }
}

/* 



















 */
</style>
